import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';

import {CodelistDetail} from '../../components/CodelistDetail/CodelistDetail';

export function WorkshopCodelistDetail() {
  return (
    <CodelistDetail
      breadcrumbs={[
        {
          label: i18n.t('entity.interest.labels.interest'),
          href: settingsRoutes.workshopInterest,
        },
      ]}
    />
  );
}
